module.exports = __webpack_public_path__ + "img/salesenquiries.92c64259.png";